export default "__VITE_ASSET__XSUgIwD8__"